import React from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import SideNavigationMenu from "./common/SideNavigationMenu";
import DashboardPage from "./dashboard/DashboardPage";
import { Row, Col } from "react-bootstrap";

const PresClubPages = (props) => {

    return (
    <>
      <Col className="rev-share-nav" xl="2" lg="3" md="4">
        <SideNavigationMenu isAdmin={props.profile.isAdmin} isManager={props.profile.isManager} />
      </Col>
      <Col xl="10" lg="9" md="8">
        <Row>
          <Switch>
            <Route exact path="/presclub/" component={DashboardPage} />
            <Route component={DashboardPage} />
          </Switch>
        </Row>
      </Col>
    </>
  ); 
};

const mapStateToProps = (state, ownProps) => {
  return { profile: state.profile };
};

export default connect(mapStateToProps)(PresClubPages);